import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryHr } from "./baseQuery";
import { API } from "./constant";

export const employeeApi = createApi({
  baseQuery: baseQueryHr,
  reducerPath: "employeeApi",
  tagTypes: [
    "self-review",
    "cross-review",
    "peer-review",
    "upward-review",
    "pip",
  ],
  endpoints: (builder) => ({
    getAppraisalSelfReview: builder.query({
      query: ({ AppraiseeId, PageSize, PageNumber }) => ({
        url: `${API.EMPLOYEE.GET_SELF_REVIEW}?AppraiseeId=${AppraiseeId}&PageNumber=${PageNumber}&PageSize=${PageSize}`,
      }),
    }),
    getAppraisalSummary: builder.query({
      query: ({ id, PageSize, PageNumber, SearchTerm, Year }) => ({
        url: `${API.EMPLOYEE.GET_SUMMARY}/${id}?PageNumber=${PageNumber}&PageSize=${PageSize}&Search=${SearchTerm}&year=${Year}`,
      }),
    }),
    getMainSelfReview: builder.query({
      query: (id) => ({
        url: `${API.EMPLOYEE.GET_MAIN_SELF_REVIEW}/${id}`,
      }),
      providesTags: ["self-review"],
    }),
    getMainSelfReviewByAppraisalType: builder.query({
      query: ({ referenceId, appraisalType, appraiserId, appraiseeId }) => ({
        url: `${
          API.EMPLOYEE.GET_MAIN_SELF_REVIEW
        }/${referenceId}?appraisalType=${appraisalType}&appraiserId=${
          appraiserId || ""
        }&appraiseeId=${appraiseeId || ""}`,
      }),
      providesTags: ["self-review"],
    }),
    submitSlefReview: builder.mutation({
      query: (data) => ({
        url: `${API.EMPLOYEE.SUBMIT_SELF_REVIEW}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["self-review"],
    }),
    getLineManagerReview: builder.query({
      query: (id) => ({
        url: `${API.EMPLOYEE.LINE_MANAGER_REVIEW}?AppraiserId=${id}`,
      }),
    }),
    getEmployeeById: builder.query({
      query: (id) => ({
        url: `${API.EMPLOYEE.GET_EMPLOYEE_BY_ID}?id=${id}`,
      }),
    }),
    change360KraFeedback: builder.mutation({
      query: ({ req }) => ({
        url: `${API.EMPLOYEE.REVIEW360_KRA}`,
        method: "POST",
        body: req,
      }),
      invalidatesTags: ["self-review"],
    }),
    acknowledgeAppraisal: builder.mutation({
      query: (req) => ({
        url: `${API.EMPLOYEE.ACKNOWLEDGE_APPRAISAL}`,
        method: "POST",
        body: req,
      }),
    }),
    getManagementReview: builder.query({
      query: (id) => ({
        url: `${API.EMPLOYEE.GET_MAIN_SELF_REVIEW}/${id}`,
      }),
      providesTags: ["self-review"],
    }),
    getCrossReview: builder.query({
      query: ({
        AppraiserId,
        PageNumber,
        PageSize,
        SearchTerm,
        PeriodStartDate,
        PeriodEndDate,
      }) => ({
        url: `${API.EMPLOYEE.CROSS_REVIEW}?CrossReviewerId=${AppraiserId}&PageNumber=${PageNumber}&PageSize=${PageSize}&SearchTerm=${SearchTerm}&PeriodStartDate=${PeriodStartDate}&PeriodEndDate=${PeriodEndDate}`,
      }),
      providesTags: ["cross-review"],
    }),
    getPeerReview: builder.query({
      query: ({
        AppraiserId,
        PageNumber,
        PageSize,
        SearchTerm,
        PeriodStartDate,
        PeriodEndDate,
      }) => ({
        url: `${API.EMPLOYEE.PEER_REVIEW}?PeerId=${AppraiserId}&PageNumber=${PageNumber}&PageSize=${PageSize}&SearchTerm=${SearchTerm}&PeriodStartDate=${PeriodStartDate}&PeriodEndDate=${PeriodEndDate}`,
      }),
      providesTags: ["peer-review"],
    }),
    getUpwardReview: builder.query({
      query: ({
        AppraiserId,
        PageNumber,
        PageSize,
        SearchTerm,
        PeriodStartDate,
        PeriodEndDate,
      }) => ({
        url: `${API.EMPLOYEE.UPWARD_REVIEW}?SubordinateId=${AppraiserId}&PageNumber=${PageNumber}&PageSize=${PageSize}&SearchTerm=${SearchTerm}&PeriodStartDate=${PeriodStartDate}&PeriodEndDate=${PeriodEndDate}`,
      }),
      providesTags: ["upward-review"],
    }),
    getAppraisalReviewDetails: builder.query({
      query: (ReferenceId) => ({
        url: `${API.EMPLOYEE.GET_EMPLOYEE_REVIE_DETAILS}/id?AppraisalId=${ReferenceId}`,
      }),
    }),
    submitPeerReview: builder.mutation({
      query: (req) => ({
        method: "POST",
        body: req,
        url: API.EMPLOYEE.SUBMIT_PEER_REVIEW,
      }),
    }),
    submitUpwardReview: builder.mutation({
      query: (req) => ({
        method: "POST",
        body: req,
        url: API.EMPLOYEE.SUBMIT_UPWARD_REVIEW,
      }),
    }),
    submitCrossReview: builder.mutation({
      query: (req) => ({
        method: "POST",
        body: req,
        url: API.EMPLOYEE.SUBMIT_CROSS_REVIEW,
      }),
    }),
    getPendingLineManagerAppraisals: builder.query({
      query: ({
        LineManagerId,
        PageNumber,
        PageSize,
        SearchTerm,
        PeriodStartDate,
        PeriodEndDate,
        Status,
        StartDate,
        EndDate,
      }) => ({
        url: `${
          API.EMPLOYEE.GET_PENDING_APPRAISALS
        }?LineManagerId=${LineManagerId}&PageNumber=${PageNumber}&PageSize=${PageSize}&SearchTerm=${SearchTerm}&PeriodStartDate=${PeriodStartDate}&PeriodEndDate=${PeriodEndDate}&AppraisalWorkflowStatus=${
          Status || ""
        }&StartDate=${StartDate || ""}&EndDate=${EndDate || ""}`,
      }),
    }),
    createLineManagerReview: builder.mutation({
      query: (body) => ({
        method: "POST",
        url: API.LINE_MANAGER_REVIEW,
        body: body,
      }),
    }),
    createLineManagerReviewSummary: builder.mutation({
      query: (body) => ({
        method: "POST",
        url: API.LINE_MANAGER_REVIEW_SUMMARY,
        body: body,
      }),
    }),
    employeePIPUpdate: builder.mutation({
      query: (data) => ({
        url: `${API.EMPLOYEE.EMPLOYEE_PIP_UPDATE}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["pip"],
    }),
    getAllPIPEmployee: builder.query({
      query: ({
        PageNumber,
        PageSize,
        GeneralSearch,
        StartDate,
        EndDate,
        AppraiseeId,
        ApprovalStatus,
      }) => ({
        url: `${API.EMPLOYEE.GET_ALL_PIP_EMPLOYEE}?PageNumber=${PageNumber}&PageSize=${PageSize}&GeneralSearch=${GeneralSearch}&StartDate=${StartDate}&EndDate=${EndDate}&AppraiseeId=${AppraiseeId}&ApprovalStatus=${ApprovalStatus}`,
      }),
      providesTags: ["pip"],
    }),
    getPIPById: builder.query({
      query: (id) => ({
        url: `${API.EMPLOYEE.GET_PIP_BY_ID}${id}`,
      }),
      providesTags: ["pip"],
    }),
    getAllPIP: builder.query({
      query: ({
        AppraiseeId,
        GeneralSearch,
        PageSize,
        PageNumber,
        ApprovalStatus,
      }) => ({
        url: `${API.EMPLOYEE.GET_ALL_PIP}?AppraiseeId=${AppraiseeId}&GeneralSearch=${GeneralSearch}&ApprovalStatus=${ApprovalStatus}&PageNumber=${PageNumber}&PageSize=${PageSize}`,
      }),
      providesTags: ["pip"],
    }),
    calculateKraScore: builder.mutation({
      query: (body) => ({
        url: API.EMPLOYEE.CALCULATE_ACTUAL_SCORE,
        method: "POST",
        body: body,
      }),
    }),
    calculateExpectedScore: builder.mutation({
      query: (body) => ({
        url: API.EMPLOYEE.CALCULATE_ACTUAL_SCORE,
        method: "POST",
        body: body,
      }),
    }),
    calculateMainScore: builder.mutation({
      query: (body) => ({
        url: API.EMPLOYEE.CALCULATE_MAIN_SCORE,
        method: "POST",
        body: body,
      }),
    }),
    saveSelfKra: builder.mutation({
      query: (data) => ({
        url: API.EMPLOYEE.SAVE_SELF_KRA,
        body: data,
        method: "POST",
      }),
      invalidatesTags: ["self-review"],
    }),
    saveHRKra: builder.mutation({
      query: (data) => ({
        url: API.HR.HR_APPRASIAL_REVIEW,
        body: data,
        method: "POST",
      }),
    }),
    savePeerReview: builder.mutation({
      query: (data) => ({
        url: API.EMPLOYEE.SAVE_PEER_REVIEW,
        body: data,
        method: "POST",
      }),
      invalidatesTags: ["peer-review"],
    }),
    saveUpwardReview: builder.mutation({
      query: (data) => ({
        url: API.EMPLOYEE.SAVE_UPWARD_REVIEW,
        body: data,
        method: "POST",
      }),
      invalidatesTags: ["upward-review"],
    }),
    saveCrossReview: builder.mutation({
      query: (data) => ({
        url: API.EMPLOYEE.SAVE_CROSS_REVIEW,
        body: data,
        method: "POST",
      }),
      invalidatesTags: ["cross-review"],
    }),
    peerReviewSummary: builder.mutation({
      query: (data) => ({
        url: API.EMPLOYEE.PEER_REVIEW_SUMMARY,
        body: data,
        method: "POST",
      }),
      invalidatesTags: ["peer-review"],
    }),
    upwardReviewSummary: builder.mutation({
      query: (data) => ({
        url: API.EMPLOYEE.UPWARD_REVIEW_SUMMARY,
        body: data,
        method: "POST",
      }),
      invalidatesTags: ["upward-review"],
    }),
    crossReviewSummary: builder.mutation({
      query: (data) => ({
        url: API.EMPLOYEE.CROSS_REVIEW_SUMMARY,
        body: data,
        method: "POST",
      }),
      invalidatesTags: ["cross-review"],
    }),
    saveLineManagerReview: builder.mutation({
      query: (data) => ({
        url: API.EMPLOYEE.SAVE_LINE_MANAGER_REVIEW,
        body: data,
        method: "POST",
      }),
      invalidatesTags: ["line-manager-review"],
    }),
    generateReport: builder.query({
      query: ({ employeeId, referenceId, format }) => ({
        url: `${API.EMPLOYEE.GENERATE_REPORT}${employeeId}?referenceId=${referenceId}&format=${format}`,
        method: "GET",
        responseHandler: (response) => response.arrayBuffer(),
      }),
    }),
  }),
});

export const {
  useGetAppraisalSelfReviewQuery,
  useGetAppraisalSummaryQuery,
  useGetMainSelfReviewQuery,
  useSubmitSlefReviewMutation,
  useCreateLineManagerReviewSummaryMutation,
  useGetLineManagerReviewQuery,
  useGetEmployeeByIdQuery,
  useChange360KraFeedbackMutation,
  useAcknowledgeAppraisalMutation,
  useGetManagementReviewQuery,
  useGetCrossReviewQuery,
  useGetPeerReviewQuery,
  useGetUpwardReviewQuery,
  useGetAppraisalReviewDetailsQuery,
  useSubmitPeerReviewMutation,
  useSubmitUpwardReviewMutation,
  useSubmitCrossReviewMutation,
  useGetPendingLineManagerAppraisalsQuery,
  useCreateLineManagerReviewMutation,
  useEmployeePIPUpdateMutation,
  useGetAllPIPEmployeeQuery,
  useGetPIPByIdQuery,
  useGetAllPIPQuery,
  useSaveSelfKraMutation,
  useCalculateKraScoreMutation,
  useCalculateMainScoreMutation,
  useSavePeerReviewMutation,
  useSaveUpwardReviewMutation,
  useSaveCrossReviewMutation,
  useGetMainSelfReviewByAppraisalTypeQuery,
  usePeerReviewSummaryMutation,
  useUpwardReviewSummaryMutation,
  useCrossReviewSummaryMutation,
  useSaveLineManagerReviewMutation,
  useSaveHRKraMutation,
  useCalculateExpectedScoreMutation,
  useGenerateReportQuery,
} = employeeApi;
